import { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './style.css';
import React from 'react';

const Sidebar = () => {
    const [auth, setAuth] = useState('');
    const [activeMenu, setActiveMenu] = useState(null); // Track which menu is active
    let navigate = useNavigate();
    const location = useLocation(); // To get the current location (URL)

    useEffect(() => {
        var auth = localStorage.getItem('email');
        setAuth(auth);
    }, [])

    useEffect(() => {
        if (auth === null) {
            navigate('/');
        }
    }, [auth, navigate]);

    // Function to handle menu click
    const handleMenuClick = (menu) => {
        setActiveMenu(prevMenu => prevMenu === menu ? null : menu);
    }

    // Keep submenu open based on the current path
    useEffect(() => {
        const currentPath = location.pathname;

        // Automatically open the correct menu based on the current path
        if (currentPath === '/viewclient' || currentPath === '/addclient') {
            setActiveMenu('clients');
        } else if (currentPath === '/products' || currentPath === '/addproduct') {
            setActiveMenu('otherproducts');
        } else if (currentPath === currentPath === '/tea' || currentPath === '/addtea') {
            setActiveMenu('teaproducts');
        } else if (currentPath === '/purchased' || currentPath === '/addpurchase') {
            setActiveMenu('Purchase');
        } else if (currentPath === '/sales' || currentPath === '/addsales') {
            setActiveMenu('Sale');
        } else if (currentPath === '/teastock' || currentPath === '/purchagetea') {
            setActiveMenu('teaPurchase');
        } else if (currentPath === '/teaslstk' || currentPath === '/teaslnw') {
            setActiveMenu('teaSale');
        } else if (currentPath === '/stockshow') {
            setActiveMenu('stock');
        } else if (currentPath === '/stockshowtea') {
            setActiveMenu('teast');
        } else if (currentPath === '/viewledger' || currentPath === '/viewstatement' || currentPath === '/debit-credit') {
            setActiveMenu('accnt');
        } else {
            setActiveMenu(null); // Close all menus if no match
        }
    }, [location.pathname]);

    return (
        <div className="">
            <div className="">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body ">
                            <div className="wrapper">
                                <nav id="sidebar">
                                    <div className="sidebar-header">
                                        <Link to="/dashboard" className="nav-link"><h3>React Desktop Application</h3></Link>
                                    </div>

                                    <ul className="list-unstyled components">
                                        {/* Clients Menu */}
                                        <li>
                                            <a id="clnt" href="#pagemenu-1" onClick={() => handleMenuClick('clients')} aria-expanded={activeMenu === 'clients'} className="dropdown-toggle">Clients</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'clients' ? 'show' : ''}`} id="pagemenu-1">
                                                <li>
                                                    <Link id="vclient" to="/viewallclient" className="nav-link">View Client</Link>
                                                </li>
                                                <li>
                                                    <Link id="adclnt" to="/addclient" className="nav-link">Add Client</Link>
                                                </li>
                                            </ul>
                                        </li>

                                        {/* Products Menu */}
                                        <li>
                                            <a id="othrprdct" href="#pagemenu-2" onClick={() => handleMenuClick('otherproducts')} aria-expanded={activeMenu === 'otherproducts'} className="dropdown-toggle">Other Product</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'otherproducts' ? 'show' : ''}`} id="pagemenu-2">
                                                <li>
                                                    <Link id="prdcts" to="/viewallproducts" className="nav-link">Products</Link>
                                                </li>
                                                <li>
                                                    <Link id="adprdct" to="/addproduct" className="nav-link">Add Product</Link>
                                                </li>                                                
                                            </ul>
                                        </li>

                                        <li>
                                            <a id="teaprdct" href="#pagemenu-3" onClick={() => handleMenuClick('teaproducts')} aria-expanded={activeMenu === 'teaproducts'} className="dropdown-toggle">Tea Product</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'teaproducts' ? 'show' : ''}`} id="pagemenu-4">                                                
                                                <li>
                                                    <Link id="teapage" to="/viewalltea" className="nav-link">Tea</Link>
                                                </li>
                                                <li>
                                                    <Link id="addtea" to="/addtea" className="nav-link">Add Tea</Link>
                                                </li>
                                            </ul>
                                        </li>

                                        {/* Sale/Purchase Menu */}
                                        <li>
                                            <a id="prchg" href="#pagemenu-5" onClick={() => handleMenuClick('Purchase')} aria-expanded={activeMenu === 'Purchase'} className="dropdown-toggle">Purchase</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'Purchase' ? 'show' : ''}`} id="pagemenu-5">
                                                <li>
                                                    <Link id="prchgstk" to="/purchased" className="nav-link">Purchased Stock</Link>
                                                </li>
                                                <li>
                                                    <Link id="prchgnw" to="/addpurchase" className="nav-link">Purchase New Item</Link>
                                                </li>                                                
                                            </ul>
                                        </li>

                                        <li>
                                            <a id="sl" href="#pagemenu-6" onClick={() => handleMenuClick('Sale')} aria-expanded={activeMenu === 'Sale'} className="dropdown-toggle">Sale</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'Sale' ? 'show' : ''}`} id="pagemenu-6">                                                
                                                <li>
                                                    <Link id="slshow" to="/sales" className="nav-link">Sale Items</Link>
                                                </li>
                                                <li>
                                                    <Link id="slnw" to="/addsales" className="nav-link">Sale New Item</Link>
                                                </li>
                                            </ul>
                                        </li>

                                        <li>
                                            <a id="teaprchg" href="#pagemenu-7" onClick={() => handleMenuClick('teaPurchase')} aria-expanded={activeMenu === 'teaPurchase'} className="dropdown-toggle">Tea Purchase</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'teaPurchase' ? 'show' : ''}`} id="pagemenu-7">
                                                <li>
                                                    <Link id="teaprchgstk" to="/teastock" className="nav-link">Tea Stock</Link>
                                                </li>
                                                <li>
                                                    <Link id="teaprchgnw" to="/purchagetea" className="nav-link">Purchase Tea</Link>
                                                </li>                                                
                                            </ul>
                                        </li>

                                        <li>
                                            <a id="teasl" href="#pagemenu-8" onClick={() => handleMenuClick('teaSale')} aria-expanded={activeMenu === 'teaSale'} className="dropdown-toggle">Tea Sale</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'teaSale' ? 'show' : ''}`} id="pagemenu-8">
                                                <li>
                                                    <Link id="teaslstk" to="/teatotalsales" className="nav-link">Tea Total Sales</Link>
                                                </li>
                                                <li>
                                                    <Link id="teaslnw" to="/teanewsales" className="nav-link">Tea New Sales</Link>
                                                </li>                                                
                                            </ul>
                                        </li>

                                        {/* Stock Menu */}
                                        <li>
                                            <a id="st" href="#pagemenu-9" onClick={() => handleMenuClick('stock')} aria-expanded={activeMenu === 'stock'} className="dropdown-toggle">Stock</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'stock' ? 'show' : ''}`} id="pagemenu-9">
                                                <li>
                                                    <Link id="streg" to="/stockshow" className="nav-link">Stock Register</Link>
                                                </li>
                                            </ul>
                                        </li>

                                        <li>
                                            <a id="teast" href="#pagemenu-10" onClick={() => handleMenuClick('teast')} aria-expanded={activeMenu === 'teast'} className="dropdown-toggle">Tea Stock</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'teast' ? 'show' : ''}`} id="pagemenu-10">
                                                <li>
                                                    <Link id="teastreg" to="/stockshowtea" className="nav-link">Tea Stock Register</Link>
                                                </li>
                                            </ul>
                                        </li>

                                        {/* Accounts Menu */}
                                        <li>
                                            <a id="accnt" href="#pagemenu-11" onClick={() => handleMenuClick('accounts')} aria-expanded={activeMenu === 'accounts'} className="dropdown-toggle">Ledger</a>
                                            <ul className={`collapse list-unstyled ${activeMenu === 'accounts' ? 'show' : ''}`} id="pagemenu-11">
                                                
                                                <li>
                                                    <Link id="vwstmnt" to="/viewstatement" className="nav-link">View Statement</Link>
                                                </li>
                                                <li>
                                                    <Link id="vwldgr" to="/viewledger" className="nav-link">Trial Balance</Link>
                                                </li>
                                                <li>
                                                    <Link id="dbcr" to="/debit-credit" className="nav-link">Debit/Credit</Link>
                                                </li>
                                                <li>
                                                    <Link id="anlstm" to="/annual-statements" className="nav-link">Annual Statements</Link>
                                                </li>
                                            </ul>
                                        </li>

                                        
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Sidebar;
